import clsx from 'clsx';
import React from 'react';
import { useState } from 'react';
import { DatePicker } from '@material-ui/pickers';
import moment from 'moment';

interface Props {
  dateRange: {
    start: Date;
    end: Date;
  };
  onDateChange(range: { start: any; end: any }): void;
  quickRange?: boolean;
  showQuickDays?: boolean;
  showQuickToDates?: boolean;
  disabled?: boolean;
}

export const DateRangeBox = ({
  dateRange,
  disabled = false,
  onDateChange,
  quickRange,
  showQuickDays,
  showQuickToDates,
}: Props) => {
  const [currentFilter, setCurrentFilter] = useState(0);
  const currentDate = new Date(Date.now());
  const wtd = new Date(
    currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 1)
  );
  const mtd = new Date(
    currentDate.setDate(currentDate.getDate() - currentDate.getDate() + 1)
  );
  const classes = useStyles();

  const handleQuickRange = (event: any) => {
    const daysFromButtonId = parseInt(event.currentTarget.id);
    const daysFromNow = new Date(
      currentDate.setDate(new Date(Date.now()).getDate() - daysFromButtonId)
    );
    if (daysFromButtonId === currentFilter) {
      setCurrentFilter(0);
      onDateChange({
        start: moment(new Date(Date.now())),
        end: moment(new Date(Date.now())),
      });
      return;
    }
    switch (daysFromButtonId) {
      case 1000:
        onDateChange({ start: moment(wtd), end: moment(new Date(Date.now())) });
        break;
      case 2000:
        onDateChange({ start: moment(mtd), end: moment(new Date(Date.now())) });
        break;
      default:
        onDateChange({ start: moment(daysFromNow), end: dateRange.end });
        break;
    }
    setCurrentFilter(daysFromButtonId);
  };

  return (
    <div className="flex flex-col items-center gap-4 p-4 w-full">
      <div className="flex flex-col sm:flex-row md:flex-col items-center justify-center gap-4 w-full">
        <DatePicker
          DialogProps={{
            className: '!z-[99999]',
          }}
          label="Start Date"
          value={dateRange.start}
          onChange={(date: any) =>
            onDateChange({ start: date, end: dateRange.end })
          }
          animateYearScrolling
          autoOk
          disableFuture
          maxDate={dateRange.end}
          inputVariant="filled"
          format="MMMM DD YYYY"
          onAccept={() => setCurrentFilter(0)}
          showTodayButton
          disabled={disabled}
        />
        <DatePicker
          DialogProps={{
            className: '!z-[99999]',
          }}
          label="End Date"
          value={dateRange.end}
          onChange={(date: any) =>
            onDateChange({ start: dateRange.start, end: date })
          }
          animateYearScrolling
          autoOk
          disableFuture
          minDate={dateRange.start}
          minDateMessage="End date cannot be before start date"
          inputVariant="filled"
          format="MMMM DD YYYY"
          onAccept={() => setCurrentFilter(0)}
          showTodayButton
          disabled={disabled}
        />
      </div>
      {quickRange ? (
        <div
          className={clsx('flex flex-col sm:flex-row md:flex-col gap-2 w-fit', {
            'pointer-events-none opacity-30': disabled,
          })}
        >
          {showQuickDays ? (
            <div className={classes.buttonGroup}>
              <button
                id="7"
                className={clsx(
                  classes.button,
                  'border-r border-border-light dark:border-border-dark',
                  {
                    [classes.selectedButton]: currentFilter === 7,
                  }
                )}
                disabled={disabled}
                onClick={handleQuickRange}
              >
                7 Days
              </button>
              <button
                id="30"
                className={clsx(classes.button, {
                  [classes.selectedButton]: currentFilter === 30,
                })}
                disabled={disabled}
                onClick={handleQuickRange}
              >
                30 Days
              </button>
            </div>
          ) : null}
          {showQuickToDates ? (
            <div className={classes.buttonGroup}>
              <button
                id="1000"
                className={clsx(
                  classes.button,
                  'border-r border-border-light dark:border-border-dark',
                  {
                    [classes.selectedButton]: currentFilter === 1000,
                  }
                )}
                disabled={disabled}
                onClick={handleQuickRange}
              >
                WTD
              </button>
              <button
                id="2000"
                className={clsx(classes.button, {
                  [classes.selectedButton]: currentFilter === 2000,
                })}
                disabled={disabled}
                onClick={handleQuickRange}
              >
                MTD
              </button>
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

const useStyles = () => ({
  button:
    'cursor-pointer text-xs uppercase p-2 hover:bg-black/10 hover:dark:bg-white/10 w-[100px]',
  buttonGroup:
    'flex justify-center whitespace-nowrap rounded border border-border-light dark:border-border-dark overflow-hidden w-full',
  selectedButton: 'bg-primary text-white hover:!bg-primary',
});
